package com.iregained.site.components.sections.financing.styles

import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.s

val ClickableLogoStyle = CssStyle {
    base {
        Modifier
            .cursor(Cursor.Pointer)
            .transition(
                Transition.of("transform", 0.2.s, TransitionTimingFunction.EaseInOut),
                Transition.of("opacity", 0.2.s, TransitionTimingFunction.EaseInOut)
            )
    }
    hover {
        Modifier
            .scale(1.05f) // Zooms in by 5%
            .opacity(0.8f) // Dims slightly
    }
}
